import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ApplicationService } from "app/services/application.service";
import { CarrierService } from "app/services/carrier.service";
import { DocumentsServiceService } from "app/services/documents-service.service";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { environment } from "environments/environment";
import { AnnualComplianceService } from "../service/annual-compliance.service";
import { PermitService } from "app/services/permit.service";
import { CorspdcService } from "app/services/corspdc.service";
import { Observable, forkJoin } from "rxjs";
import { map } from "rxjs/operators";
import { AuthWebService } from "app/services/authweb.service";
import { FormBuilder } from "@angular/forms";
import { CountryService } from "app/services/country.service";
import { SharedModule } from 'app/shared.module';
import {StepperContainerComponent} from '../../shared/stepper/stepper-container/stepper-container.component';
import { forEach } from "angular";
import { WorkflowService } from "app/services/workflow.service";

export const enum PAYMENT_METHOD {
  WALLET = "1",
  PAYGATE = "2",
}

@Component({
  selector: 'app-compliancepayment',
  templateUrl: './compliancepayment.component.html',
  styleUrls: ['./compliancepayment.component.scss']
})
export class CompliancepaymentComponent implements OnInit {

  selectedPermits = [];
  complianceIds: any=[];
  nextYearDate: Date;
  count: number;
  ids: string;
  pageNumber: number = 1;
  currentId: number;
  currentPermitDetails: any = [];
  currentDuplicateDetails: any = [];
  uploadedDocs: any;
  permitDocumentsLink: any = [];
  @ViewChild("content") modal: NgbModal;
  isLoading: boolean = false;
  allDocs: any;
  message = "Loading Documents...";
  removeRef: any;
  pdfSrc: any;
  img: any;
  carrierId: any;
  accountBalance: any;
  complianceDetails: any;
  documentPayload = [];
  carrierDetails: any = [];
  compliantStatuses: any;
  user: any = {};
  countryName: any;
  countries:any = [];
  total:number=0;

    // Step 2 Variables
    complianceVehicleDetails: any = [];
    SelectedcomplianceVehicleDetails: any = [];
    permitPaymentDetails: any = [];
    feeToBePaid: number;
  
    //Varibles to Manage Stepper
    background1 = "var(--sapphire)";
    background2 = "var(--background)";
    background3 = "var(--background)";
  
    isProgress1 = true;
    isProgress2 = false;
    isProgress3 = false;
  
    isStepper1 = true;
    isStepper2 = false;
    isStepper3 = false;
  
    // PAYMENT FORM
    checkoutForm = this.formBuilder.group({
      PAY_REQUEST_ID: "",
      CHECKSUM: "",
    });
    payGateUrl: string = "https://secure.paygate.co.za/payweb3/process.trans";
    payReqId: string = "";
    checkSum: string = "";

    @ViewChild(StepperContainerComponent) StepperContainer;
    @Output() nextStepEmitter = new EventEmitter<number>();
    @Output() prevStepEmitter = new EventEmitter<number>();
  applicationId: number;
  permitId: number;

    constructor(
      private formBuilder: FormBuilder,
      private authWebService: AuthWebService,
      private _router: Router,
      private _activatedRoute: ActivatedRoute,
      private _confirmDialogService: ConfirmDialogService,
     // private _toastService: ToastNotificationService,
      private _applicationService: ApplicationService,
      private _document: DocumentsServiceService,
      private _carrier: CarrierService,
      private confirmDialogService: ConfirmDialogService,
      private documentService: DocumentsServiceService,
      private toastService: ToastNotificationService,
      private _annualCompliance: AnnualComplianceService,
      private _location: Location,
      private _permit: PermitService,
      private _correspondance: CorspdcService,
      private _country:CountryService,
      private workflowService: WorkflowService
    ) {
      this.user = this.authWebService.userData
        ? this.authWebService.userData.User
        : null;
    }

  ngOnInit(): void {
    localStorage.removeItem("ComplianceIdsSubmitted");
    this.ids = this.getIdFromUrl(window.location.href);
    // this.ids = this._activatedRoute.snapshot.paramMap.get("ids");
     this.getIDs();
     //this.getPaymentInfo();
     //this.complianceIds = this._activatedRoute.snapshot.paramMap.get("id");
     if (this.complianceIds) this.getApplicationDetails();
   } 
  
   getApplicationDetails() {
     this.isLoading = true;
     this._annualCompliance
       .getAnnualComplianceDetailsById(this.currentId)
       .subscribe(
         (res: any) => {
           if (res) {
             this.complianceDetails = res;
             console.log("SavingComps", res);
             if (res.permit_id) this.getPermitDetailsById();
             this.isLoading = false;
           }
         },
         (err) => {
           console.error(err);
           this.isLoading = false;
         }
       );
   }
 
   saveCompliance() {
    const currentDate = new Date();
    this.nextYearDate = new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDate());
 
     if (this.complianceDetails) {
       const currentDets = {
         id: this.currentId,
         //submission_id: this.complianceDetails.submission_id,
         permit_id: this.complianceDetails.permit_id,
         date_ac_due: this.complianceDetails.date_ac_due,
         status_id:this.complianceDetails.status_id,
         is_valid: this.complianceDetails.is_valid,
         compliance_issue: this.complianceDetails.compliance_issue,
         Is_duplicate: this.complianceDetails.Is_duplicate,
         face_value_num: this.complianceDetails.face_value_num,
         date_valid_from: this.complianceDetails.date_valid_from,
         date_valid_to: this.complianceDetails.date_valid_to,
         date_approved: this.complianceDetails.date_approved,
         date_rejected: this.complianceDetails.date_rejected,
         date_created: this.complianceDetails.date_created,
         date_modified: this.complianceDetails.date_modified,
         date_submitted: currentDate,
      //   compliance_status:"Fee Paid",
         user_created: this.complianceDetails.user_created,
         user_modified: this.complianceDetails.user_modified,
         compliance_fee: this.complianceDetails.compliance_fee,
         duplicate_fee: this.complianceDetails.duplicate_fee,
         is_paid: true,
         printed_by: this.complianceDetails.printed_by,
         date_ac_reminder_1: this.complianceDetails.date_ac_reminder_1,
         date_ac_reminder_2: this.complianceDetails.date_ac_reminder_2,
         date_ac_reminder_3: this.complianceDetails.date_ac_reminder_3,
         date_ac_overdue_reminder_1:
           this.complianceDetails.date_ac_overdue_reminder_1,
         date_ac_overdue_reminder_2:
           this.complianceDetails.date_ac_overdue_reminder_2,
         date_ac_overdue_reminder_3:
           this.complianceDetails.date_ac_overdue_reminder_3,
         year_num: this.complianceDetails.year_num,
         date_invoiced: this.complianceDetails.date_invoiced,
       };
       this._annualCompliance.saveCompliance(currentDets).subscribe((res: any)=>{this.currentPermitDetails=res;})
       console.log("current details",currentDets);
       this.toastService.success("Submission Successful","Compliance successfully submitted");
       this.initiateWorkflow();
       this.cancel();
       //this._router.navigate([`annual-compliance/confirmation/${this.currentId}`])
     }
   }
   
 
  async getPermitDetailsById(): Promise<void> {
    this.isLoading = true;
    return new Promise<void>((resolve, reject) => {
    this._annualCompliance.getAnnualComplianceDetailsById(this.currentId).subscribe(
      (res: any) => {
        if (res) {

          this.currentPermitDetails = res;
          this.carrierId = res.carrier_id;
          this.applicationId = res.application_id;
          this.getCountries();

        }
        this.isLoading = false;
        // this.getAccountBalance(this.currentPermitDetails.carrier_account_id);
      },
      (err) => {
        this.isLoading = false;
        console.error(err);
      }
    );
  });
  }

  getPermitDetailsByIdPayment() {
    this._annualCompliance.getAnnualComplianceDetailsById(this.currentId).subscribe(
      (res: any) => {
        if (res) {
          this.getAccountBalance(res.carrier_account_id);
          this.carrierId = res.carrier_id;
          if(res.Is_duplicate)
          {
          this.getComplianceDuplicateDetails();
          }
          else{
            this.getComplianceVehicleDetails();
          }
        }
        this.isLoading = false;

      },
      (err) => {
        this.isLoading = false;
        console.error(err);
      }
    );
  }

  getComplianceDetailsByVIN() {
    this.isLoading = true;
    const obj = {
      vin: this.currentPermitDetails.vin,
      company_regnumber: this.currentPermitDetails.registration_number,
    };
    this._annualCompliance.getComplianceStatuses(obj).subscribe(
      (res: any) => {
        if (res) {
          this.compliantStatuses = res;
          this.isLoading = false;
        } else {
          this.isLoading = false;
        }
      },
      (err) => {
        this.isLoading = false;
        console.error(err);
      }
    );
  }

  /**
   * Method to get the Linked documents which can be uploaded for the permit
   */
  getPermitRelatedDocsByID() {
    // this.isLoading = true;
    // this._permitDocs
    //   .getLinkedAndUnlinkedDoctypes(this.currentPermitDetails.permit_type_id)
    //   .subscribe(
    //     (res: any) => {
    //       if (res && res.PermitLinked) {
    //         this.permitDocumentsLink = res.PermitLinked;
    //         this.getPermitDocumentsById();
    //       }
    //       this.isLoading = false;
    //     },
    //     (err) => {
    //       console.error(err);
    //       this.isLoading = false;
    //     }
    //   );
  }

  async getCountries() {
    try {
      this.isLoading = true;
      const result = await this._country.listAllCountries().toPromise();
      if (result) {
        this.countries = result;
        this.isLoading = false;
        this.countries.forEach((country) => {
          if (country.id == this.currentPermitDetails.country) {
            this.countryName = country.desc;
            console.log(this.countryName);
            return;
          }
        });
      }
    } catch (error) {
      this.isLoading = false;
    }
  }

  getPermitDocumentsById() {
    this.isLoading = true;
    this._document
      .getPermitById(this.currentPermitDetails.permits[0].application_id)
      .subscribe((res: any) => {
        if (res) {
          this.uploadedDocs = res;
          this.patchDocs();
        }
      });
  }

  //Go back to the listing page
  cancel() {
    this.carrierId
      ? this._router.navigate([`/annual-compliance/list/${this.currentPermitDetails.carrier_id}`])
      : history.back();
  }

  patchDocs() {
    let newArr = [];
    this.permitDocumentsLink.forEach((element) => {
      const document_type_id = element.document_type_id;
      const foundEl: Array<any> = this.uploadedDocs.filter(
        (item) => item.document_type_id == document_type_id
      );
      if (foundEl && foundEl.length) {
        foundEl.forEach((el) => {
          newArr.push({
            document_type_id: document_type_id,
            fileName: el.file_name,
            id: el.id,
            document_link: el.document_link,
            date_created: el.date_created,
          });
        });
      }
    });
    this.allDocs = newArr.reduce((groups, item) => {
      const group = groups[item.document_type_id.toString()] || [];
      group.push(item);
      groups[item.document_type_id] = group;
      return groups;
    }, {});
  }

  onClickSubmit(val) {
    switch (val) {
      case 2:
        if (this.documentPayload.length < 0) {
          return;
        } else {
          this.useDocument();
          break;
        }
      case 3:
        // this.hideStepTwoFromBeingActive();
        // this.stepThreeActiveTab();
        this.next();
        break;
    }
  }

  useDocument() {
    this.isLoading = true;
    this._document.useThisDocument(this.documentPayload).subscribe(
      (res: any) => {
        if (res) {
          this.isLoading = false;
          this.hideStepOneFromBeingActive();
          this.stepTwoActiveTab();
          this.getCarrierDetails();
          this.getPaymentInfo();
        }
      },
      (err) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

    //Get Compliance Certificate Payment Screen Details
    getComplianceVehicleDetails() {
      this.isLoading = true;
      this._annualCompliance.getCompliancesSelected(this.ids).subscribe(
        (response) => {
          this.isLoading = false;
          this.complianceVehicleDetails = response;
          this.complianceVehicleDetails.forEach(compliance => 
             { 
              this.total=this.total+compliance.line_total + compliance.duplicate_fee
            });
        },
        (err) => {
          console.error(err);
          this.isLoading = false;
        }
      );
    }
    getComplianceDuplicateDetails() {
      this.isLoading = true;
      this._annualCompliance.getCompliancesSelectedDuplicate(this.ids).subscribe(
        (response) => {
          this.isLoading = false;
          this.complianceVehicleDetails = response;
          this.complianceVehicleDetails.forEach(compliance =>  { 
            this.total=this.total+compliance.line_total + compliance.duplicate_fee
          });
        },
        (err) => {
          console.error(err);
          this.isLoading = false;
        }
      );
    }
  
    //Get Payment Info of Compliance
    getPaymentInfo() {
      this.isLoading = true;
      this._permit.getPaymentInfoForAnnualCompliance(this.currentId).subscribe(
        (res: any) => {
          this.permitPaymentDetails = res;
          this.feeToBePaid = res.line_total;
          this.permitId = res.permit_id;
          this.isLoading = false;
        },
        (err) => {
          console.error(err);
          this.isLoading = false;
        }
      );
    }

   // ------------Methods to Manage Stepper----------------------//
   jumpToDoc() {
    this.stepOneActiveTab();
    this.hideStepTwoFromBeingActive();
    this.hideStepThreeFromBeingActive();
  }

  stepOneActiveTab() {
    const stepOne = <HTMLElement>document.getElementsByClassName("step-one")[0];
    stepOne.style.fontSize = "20px";
    stepOne.style.fontWeight = "bold";
  }

  stepTwoActiveTab() {
    const stepTwo = <HTMLElement>document.getElementsByClassName("step-two")[0];
    stepTwo.style.fontSize = "20px";
    stepTwo.style.fontWeight = "bold";
    this.getAccountBalance(
      this.currentPermitDetails.carrier_account_id
    );
  }

  stepThreeActiveTab() {
    const stepTwo = <HTMLElement>(
      document.getElementsByClassName("step-three")[0]
    );
    stepTwo.style.fontSize = "20px";
    stepTwo.style.fontWeight = "bold";
  }

  hideStepOneFromBeingActive() {
    this.isStepper2 = true;
    this.isProgress1 = false;
    this.isStepper1 = false; //Hide Tab 1
    this.background2 = "var(--sapphire)";
    const element = <HTMLElement>document.getElementsByClassName("step-one")[0];
    element.style.fontSize = "16px";
    element.style.fontWeight = "lighter";
  }

  hideStepTwoFromBeingActive() {
    this.isStepper3 = true;
    this.isProgress2 = true;
    this.background3 = "var(--sapphire)";
    const element = <HTMLElement>document.getElementsByClassName("step-two")[0];
    element.style.fontSize = "16px";
    element.style.fontWeight = "lighter";
  }

  hideStepThreeFromBeingActive() {
    this.background1 = "var(--sapphire)";
    this.background2 = "var(--background)";
    this.background3 = "var(--background)";

    this.isProgress1 = true;
    this.isProgress2 = false;
    this.isProgress3 = false;

    this.isStepper1 = true;
    this.isStepper2 = false;
    this.isStepper3 = false;
    const element = <HTMLElement>(
      document.getElementsByClassName("step-three")[0]
    );
    element.style.fontSize = "16px";
    element.style.fontWeight = "lighter";
  }

  // ------------Methods to Manage Stepper (END)-----------------//

    //Get Carrier Details
    getCarrierDetails() {
      this.isLoading = true;
      this._carrier.getCarrierById(this.currentPermitDetails.carrier_id).subscribe((res: any) => {
        this.carrierDetails = res;
      });
    }

    getAccountBalance(customerCode) {
      if (customerCode) {
        this._carrier.getUpdateBalance(customerCode).subscribe((res: any) => {
          this.accountBalance = -res.Result.AccountBalance;
        });
      }
    }


    // goNext(){
    //   this.StepperContainer.activeStepper.isProgress = 'false';
    //   this.StepperContainer.next();
    // }

     back(){
       this.StepperContainer.previous();
     }

    getIDs() {
      if (this.ids) {
        this.complianceIds = this.ids.split("_");
        this.currentId = this.complianceIds[0];
        this.getPermitDetailsById();
        this.getPermitDetailsByIdPayment();
      }
    }

    getIdFromUrl(url: string): string | null {
      const regex = /\/(\w+)$/; // Matches a word at the end of the URL
      const matches = regex.exec(url);
      if (matches && matches.length >= 2) {
        return matches[1];
      }
      return null; // ID not found or invalid URL
    }

    submitApplication(paymentMethod) {
      this.isLoading = true;
        switch (paymentMethod) {
          case PAYMENT_METHOD.WALLET:
            this.payUsingAccountBalance();
            this.isLoading = false;
            break;
          case PAYMENT_METHOD.PAYGATE:
            this.PayGate();
            this.isLoading = false;
            break;
        }
          
        (err) => {
          this.isLoading = false;
          console.error(err);
        }   
    }

  next() {
    this.nextStep();
  }

  nextStep(){
    this.nextStepEmitter.emit(0)
  }

  prevStep(){
    this.prevStepEmitter.emit(0)
  }

  async payUsingAccountBalance(): Promise<void>  {
    if (this.accountBalance < this.feeToBePaid) {
      return;
    } else {
      this.InvoiceFromComplianceIdsAsync();
      // this.complianceVehicleDetails.forEach(compliance => {
      //   this.currentId=compliance.id;
      //   this.getPermitDetailsById();
      //   this.generateInvoice();})
    }
  }
  PayGate(){
    this.ids = this.getIdFromUrl(window.location.href);
    localStorage.setItem("ComplianceIdsSubmitted" ,this.ids );
    this._router.navigate(["/carrier/fundaccount/" + this.currentPermitDetails.carrier_id ]);
}
  async payUsingPaygate() {
    try {
      this.isLoading = true;
      const payload = {
        CarrierId: this.currentPermitDetails.carrier_id,
        AMOUNT: this.feeToBePaid,
      };

      const response = await this._annualCompliance
        .payUsingPaygate(payload)
        .toPromise();
      const body = {
        referenceid_carrierId: this.currentPermitDetails.carrier_id + "_" + response,
        EMAIL: this.user.UserName,
        REFERENCE: response,
        AMOUNT: this.feeToBePaid * 100 + "",
      };
      console.log(body);
      const responseInitiate: any = await this._annualCompliance
        .paymentSuccessPaygate(body)
        .toPromise();
      this.payReqId = responseInitiate.PAY_REQUEST_ID;
      this.checkSum = responseInitiate.CHECKSUM;
      //Payment Initiate Successfull
      if (this.payReqId != null && this.checkSum != null) {
        this.checkoutForm.patchValue({
          PAY_REQUEST_ID: this.payReqId,
          CHECKSUM: this.checkSum,
        });
        let formSubmitBtn = document.getElementById("checkoutFormBtn");
        formSubmitBtn.click();
        this.isLoading = false;
        // this._annualCompliance.UpdateComplianceStatuses(this.currentPermitDetails.id , "AnnComplianceStatus3").subscribe((result: any) => { 
        // });
        console.log("success");
      }
      //Payment Initaitaion failed
      else {
        console.log("failed");
        this.isLoading = false;
      }
    } catch (err) {
      this.isLoading = false;
      console.error(err);
    }
  }

  async generateInvoice():Promise<void> {
    this.isLoading = true;
    return new Promise<void>((resolve, reject) => {

    const payload = {
      ComplianceId: this.currentId,
      CustomerCode: this.currentPermitDetails.carrier_account_id,
      Description: `Invoice for ${this.currentId}`,
      ExclusiveTotal: this.feeToBePaid,
      InclusiveTotal: 0,
      InvoiceDate: new Date().toISOString(),
      InvoiceNumber: "",
      PermitType: this.currentPermitDetails.permit_type_id,
      TaxAmount: 0,
      invoiceItems: [],
    };

    this.permitId = this.currentPermitDetails.permit_id;
        const obj = {
      Description: `${this.currentPermitDetails.line_total} for compliance ${this.currentId}`,
      ItemCode: this.currentPermitDetails.compliance_product_link
        ? this.currentPermitDetails.compliance_product_link
        : "",
      PermitId: this.permitId,
      line_total: 0,
      quantity: "1",
      unit_price: this.currentPermitDetails.line_total,
    };
    payload.invoiceItems.push(obj);
    console.log("invoice payload",payload);
    this._annualCompliance.createCompliancePaymentInvoice(payload).subscribe(
      (res: any) => {
        console.log("response",res);
       // this.saveCompliance();
        this.getAccountBalance(this.currentPermitDetails.carrier_id);
        this.isLoading = false;
        this.toastService.success("Submission Successful","Compliance successfully updated");
        // this._annualCompliance.getPermitVehicleDetailsConfimation(this.currentPermitDetails.carrier_id);
        // this._annualCompliance.getComplianceCertificatesConfirmationScreenForDuplicate(this.currentPermitDetails.carrier_id);
        this.cancel();
        // this.onClickSubmit(3);  to be determined if necessary
      },
      (err) => {
        this.isLoading = false;
      }
    );

  });
  }

  onSubmit(form: any, e: any): void {
    // Process checkout data here

    e.target.submit();
  }

  async InvoiceFromComplianceIdsAsync(): Promise<any> {
    try {

      this.ids = this.getIdFromUrl(window.location.href);
      const stringArray: string[] = this.ids.split("_"); // Split the string into an array
      const numberArray: number[] = stringArray.map(str => parseInt(str, 10));

      for (const id of numberArray) {
        this._annualCompliance.UpdateComplianceStatuses(id , "AnnComplianceStatus3").subscribe((result: any) => { 

        });
      }


      this.initiateWorkflow();
      this.cancel();
      this.toastService.success("Submission Successful","Compliance successfully submitted");
     // return result;
      
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }
  // InvoiceFromComplianceIdsAsync() { const ids = [51315, 51317]; this.complianceService.createInvoices(ids) .then(response => { // Handle the response here }) .catch(error => { // Handle the error here }); } }

    //#region Workflow
    initiateWorkflow() {

      this.ids = this.getIdFromUrl(window.location.href);
      const stringArray: string[] = this.ids.split("_"); // Split the string into an array
      const numberArray: number[] = stringArray.map(str => parseInt(str, 10));

      for (const id of numberArray) {
          this.workflowService.initiateComplianceWorkflow(id )
            .subscribe(
              async (result: any) => {
                console.log(result);
              },
              (error) => {
                this.isLoading = false;
              }
            );

      }
    }
  
    //#region
}
